import React from 'react'
import {useIntl, FormattedMessage} from 'react-intl'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import {Link as RouterLink} from 'react-router-dom'
import {Formik} from 'formik'
import * as Yup from 'yup'
import {makeStyles} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import LoaderButton from 'components/atoms/LoaderButton'

const ForgotPasswordSchema = Yup.object().shape({
  username: Yup.string()
    .required('formValidations.required')
    .email('formValidations.invalidEmail'),
})

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export default function ForgotPasswordForm({handleSubmit, isSubmitting}) {
  const classes = useStyles()
  const intl = useIntl()

  return (
    <Formik
      validationSchema={ForgotPasswordSchema}
      initialValues={{username: ''}}
      onSubmit={handleSubmit}
    >
      {({values, errors, touched, handleChange, handleBlur, handleSubmit}) => (
        <form onSubmit={handleSubmit} className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label={intl.formatMessage({id: 'email'})}
            name="username"
            autoComplete="email"
            autoFocus
            value={values.username}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.username && Boolean(errors.username)}
            helperText={
              touched.username &&
              errors.username &&
              intl.formatMessage({id: errors.username})
            }
          />
          <LoaderButton
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            loadingText={intl.formatMessage({id: 'forgotPassword.submitting'})}
            isLoading={isSubmitting}
          >
            <FormattedMessage id="forgotPassword.button" />
          </LoaderButton>
          <Grid container>
            <Grid item xs>
              <Link to="/login" variant="body2" component={RouterLink}>
                <FormattedMessage id="forgotPassword.backToLogin" />
              </Link>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  )
}
